import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {},
  label: {
    fontSize: '13px',
    color: '#455a64',
    marginTop: theme.spacing(1),
    '&.MuiInputLabel': {
      '&-shrink': {
        transform: 'translate(0, 1.5px) scale(1)',
      },
    },
  },
  asterisk: {
    color: '#ef5350',
  },
}));

